import React from 'react';
import { Redirect } from 'react-router-dom';
import { authenticationService } from '../services/authenticationService';
import { Role } from '../app/role';

export const Home = () => {
    const currentUser = authenticationService.currentUserValue;

    const getRedirectPath = () => {
        if (!currentUser) {
            return "login";
        }

        switch (currentUser.role) {
            case Role.Administrator:
                return "administrator";

            case Role.User:
                return "user";

            default:
                return "login";
        }
    }

    return (
        <Redirect to={"/" + getRedirectPath()} />
    );
}